import { NgTemplateOutlet } from "@angular/common"
import {
	Component,
	Input,
	OnInit,
	ChangeDetectionStrategy,
} from "@angular/core"
import { CcParamsGen } from "@app/cc-params-gen/cc-params-gen"
import { CcSectionsComponent } from "@app/cc-sections/cc-sections.component"
import { COMMON_IMPORTS } from "@app/common-imports"
import { ConfirmComponent } from "@app/confirm/confirm.component"
import { GenButtonGroupComponent } from "@app/gen-inputs/gen-button-group/gen-button-group.component"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { GenSelectComponent } from "@app/gen-inputs/gen-select/gen-select.component"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { LangValPipe } from "@app/utils/lang-val.pipe"

@Component({
	selector: "app-cc-params-taxes",
	imports: [
		COMMON_IMPORTS,
		LangValPipe,
		GenSelectComponent,
		NgTemplateOutlet,
		GenButtonGroupComponent,
		CcSectionsComponent,
		GenInputComponent,
		ModalWrapComponent,
		ConfirmComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./cc-params-taxes.component.html",
})
export class CcParamsTaxesComponent extends CcParamsGen {
	modalProps: any = null
	//inheriting most functions and fields!
	saveObjName: string = "taxes" //which part to save while updating

	onAccountTypeChange() {
		//changes the withoutvat field according to the account type (default to "no")
		this.configcliniq.withoutvat =
			this.configcliniq.tax_account_type == "op" ? "yes" : "no"
	}
	handleIPFChange() {
		this.validateAndSave()
		if (this.needsIPFValidation()) {
			this.modalProps = { name: "confirm-ipf-change" }
		}
	}
}
